import { render } from "./1HeroOffer.vue?vue&type=template&id=54cf867d&scoped=true"
import script from "./1HeroOffer.vue?vue&type=script&lang=js"
export * from "./1HeroOffer.vue?vue&type=script&lang=js"

import "./1HeroOffer.vue?vue&type=style&index=0&id=54cf867d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54cf867d"]])

export default __exports__